import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { Select } from "react-input-textboxs";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Button,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core/";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Autocomplete from "@material-ui/lab/Autocomplete";

import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import MuiAudioPlayer from "./../../../Components/AudioPlayer";
import {
  getAuditedListByUser,
  fetchQATranscriptionAudio,
  setPageName,
  superQAAudioDecision,
  fetchRejectReajonList,
  fetchSQAAudio,
  SQAAudioDecision,
  fetchAuditUserList,
} from "./../../../service/action/audio-track-action";
import { Loader, DatePicker } from "./../../../Components";

const options = ["Option 1", "Option 2"];

const csvFileName = {
  "Translation Details": "RPT-GET-Translation-Details",
  "Recording Details": "RPT-GET-RecordingDetails",
  "Recording Audit Details": "RPT-GET-RecordingAuditDetails",
  "Rejected Record Details": "RPT-GET-RejectedRecordDetails",
  "Transcripted Details": "RPT-GET-TranscriptDetails",
  "Keyword Report Date Based": "Keyword-Report-DateBased",
};

class ApproveTranscript extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: {
        startDate: "",
        endDate: "",
      },
      user_id: "",
      pageNumber: 1,
      records: {},
      recordsError: {},
      transcriptText: "",
      model: false,
      reason: "",
      selectedId: "",
      searchValue: "",
      inputValue: "",
      selectedOption: "1",
    };
    this.rederAudioFiles = this.rederAudioFiles.bind(this);
    this.renderRejectReasonModel = this.renderRejectReasonModel.bind(this);
    this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
    this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
  }
  // componentWillReceiveProps(nextProps) {
  //   const {
  //     QAManagement: { success },
  //   } = this.props;
  // const { records, recordsError } = this.state;
  // if (superQACheck.data !== nextProps.QAManagement.superQACheck.data) {
  //   nextProps.QAManagement.superQACheck.data.map((item, i) => {
  //     records[item.id] = item.transcript;
  //     recordsError[item.id] = false;
  //   });
  //   this.setState({ records, recordsError });
  // }
  // if (
  //   nextProps.QAManagement.success.message !== "" &&
  //   success.message !== nextProps.QAManagement.success.message
  // ) {
  //   const {
  //     filterValues: { startDate, endDate },
  //     user_id,
  //   } = this.state;
  //   let start_date = "";
  //   let end_date = "";
  //   if (startDate !== "" && endDate !== "") {
  //     let sdate = new Date(startDate);
  //     let edate = new Date(endDate);
  //     start_date = `${sdate.getFullYear()}-${
  //       sdate.getMonth() + 1
  //     }-${sdate.getDate()} 00:00:00`;
  //     end_date = `${edate.getFullYear()}-${
  //       edate.getMonth() + 1
  //     }-${edate.getDate()} 23:59:59`;
  //   }
  //   this.props.getAuditedListByUser(user_id, start_date, end_date);
  // }
  // if (
  //   nextProps.QAManagement.success.message !== "" &&
  //   success.message !== nextProps.QAManagement.success.message
  // ) {
  //   const {
  //     userLogin: { loggedUser },
  //   } = this.props;
  //   this.props.fetchSQAAudio(
  //     loggedUser.username || cookie.load("username"),
  //     loggedUser.userType
  //   );
  //   this.props.fetchRejectReajonList();
  // }
  // if (
  //   nextProps.QAManagement.superQACheck.data.length === 1 &&
  //   this.props.QAManagement.superQACheck.data.length === 0
  // ) {
  //   this.setState({
  //     transcriptText: nextProps.QAManagement.superQACheck.data[0].transcript,
  //   });
  // }
  // }

  // componentWillMount() {
  //   this.props.setPageName("Super Admin QA");
  //   const {
  //     userLogin: { loggedUser },
  //   } = this.props;
  //   this.props.fetchSQAAudio(
  //     loggedUser.username || cookie.load("username"),
  //     loggedUser.userType
  //   );
  //   this.props.fetchRejectReajonList();
  // }

  handleOnChange(e, key) {
    var reg = /^[a-zA-Z\s*]*$/i;
    const { records, recordsError } = this.state;
    if (reg.test(e.target.value)) {
      records[key] = e.target.value.replace(/(\r\n|\n|\r)/gm, "");
      recordsError[key] = false;
      this.setState({ records, recordsError });
    } else {
      records[key] = e.target.value.replace(/(\r\n|\n|\r)/gm, "");
      recordsError[key] = true;
      this.setState({ records, recordsError });
    }
  }

  handleModelFormValueChange(value, key) {
    this.setState({ [key]: value });
  }

  handleModel(value) {
    this.setState({ model: value });
    document.getElementById("overlay").classList.toggle("overlay");
  }

  handleDateChange(value, key) {
    const { filterValues } = this.state;
    filterValues[key] = value === null ? "" : value;
    this.setState({ filterValues });
  }

  handleSelectedOption = (event) => {
    console.log(event.target.value);
    this.setState({
      selectedOption: event.target.value,
    });
  };

  handleQAAudioDecision(e) {
    e.preventDefault();
    const {
      userLogin: { loggedUser },
      QAManagement: { rejectReasons },
    } = this.props;
    const { selectedId, transcriptText, reason, records } = this.state;
    const det = rejectReasons.find((data) => reason === data.error);
    this.handleModel(false);

    this.props.SQAAudioDecision(
      cookie.load("username"),
      selectedId,
      "2",
      records[selectedId],
      det.error_id,
      loggedUser.userType
    );
  }
  renderRejectReasonModel() {
    const { reason } = this.state;
    const {
      QAManagement: { rejectReasons },
    } = this.props;
    const opt = rejectReasons.map((data) => data.error);

    return (
      <div className="update-model">
        <h2 style={{ marginBottom: 20 }}>Reason for Rejection?</h2>
        <form>
          <Select
            value={reason}
            onChange={(value) =>
              this.handleModelFormValueChange(value, "reason")
            }
            filter
            label="Select Reason"
            options={opt}
          />
          {reason !== "" ? (
            <div className="btn-wrapper">
              <button
                onClick={(e) => this.handleQAAudioDecision(e)}
                type="submit"
                className="btn submit-btn"
              >
                Submit
              </button>
              <button
                onClick={() => this.handleModel(false)}
                type="submit"
                className="btn clear-btn"
              >
                Cancel
              </button>
            </div>
          ) : (
            <div className="btn-wrapper">
              <button
                onClick={(e) => e.preventDefault()}
                type="submit"
                className="btn submit-btn"
              >
                Submit
              </button>
              <button
                onClick={() => this.handleModel(false)}
                type="submit"
                className="btn clear-btn"
              >
                Cancel
              </button>
            </div>
          )}
        </form>
      </div>
    );
  }
  rederAudioFiles(list) {
    const {
      userLogin: { loggedUser },
    } = this.props;
    const { recordsError, records, transcriptText } = this.state;
    return list.map((item, i) => {
      return (
        <ExpansionPanel
          expanded
          key={item.file_path + i}
          className={(i + 1) % 2 === 0 ? "even" : "add"}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <div className="flexhvc">
              <PlayCircleFilledIcon />
              <p style={{ paddingLeft: 10 }}>
                {item.path.replace(`http://10.101.1.134/rec/`, ``)}
              </p>
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="audio-result">
              <MuiAudioPlayer src={item.path} autoPlay={true} />
              {/* <p style={{paddingBottom:10}}>Letters,space and asterisk(*) only allowed!!!</p> */}
              <div className="audio-infor">
                <div className="info-item">
                  <span className="head">Recorded By:</span>
                  <span className="answer">{item.RecordedBy}</span>
                </div>
                <div className="info-item">
                  <span className="head">Audited By:</span>
                  <span className="answer">{item.AuditedBy}</span>
                </div>
                <div className="info-item">
                  <span className="head">QA Status:</span>
                  <span className="answer">
                    {item.quality_status === 2 ? "Rejected" : "Approved"}
                  </span>
                </div>
                <div className="info-item">
                  <span className="head">Language:</span>
                  <span className="answer">{item.lan}</span>
                </div>
              </div>
              <TextField
                error={recordsError[item.id]}
                id="outlined-multiline-static"
                label={` ${
                  recordsError[item.id]
                    ? `Letters,space and asterisk(*) only allowed!!!`
                    : "Enter the Transcript "
                }`}
                multiline
                rows="4"
                //value={records[item.id]}
                value={item.transcript}
                readOnly
                //onChange={e => this.setState({ transcriptText: e.target.value })}
                onChange={(e) => this.handleOnChange(e, item.id)}
                onKeyDown={(e) => this.handleOnChange(e, item.id)}
                variant="outlined"
              />
              {/* props.saveAudioTracks({ item, transcript: transcript[i] }) */}
              <div className="btn-wrapper">
                <Button
                  style={{ backgroundColor: "#bf1a1a" }}
                  disabled={recordsError[item.id]}
                  //onClick={() => this.props.QAAudioDecision(cookie.load('username'), item.id, '2', transcriptText, loggedUser.userType)}
                  onClick={() => [
                    this.handleModel(true),
                    this.setState({ selectedId: item.id }),
                  ]}
                  variant="contained"
                  color="primary"
                >
                  Rejected
                </Button>
                <Button
                  style={{ marginLeft: 10, backgroundColor: "#376704" }}
                  disabled={recordsError[item.id]}
                  onClick={() =>
                    this.props.SQAAudioDecision(
                      cookie.load("username"),
                      item.id,
                      "1",
                      records[item.id],
                      0,
                      loggedUser.userType
                    )
                  }
                  variant="contained"
                  color="primary"
                >
                  Approved
                </Button>
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      );
    });
  }
  handleSearchTextChange(value) {
    console.log(value);
    // console.log(value.length);

    this.setState({ inputValue: value });
    this.props.fetchAuditUserList(value);
  }

  handleSearchValueChange(event, value) {
    event.preventDefault();
    const {
      QAManagement: { superAuditUserList },
    } = this.props;
    console.log(superAuditUserList.data);
    console.log(value);
    const userObj =
      (superAuditUserList &&
        superAuditUserList.data.find(
          (element) => element.login_id === value
        )) ||
      null;
    // console.log(userObj.user_id);
    if (userObj === null) {
      this.setState({ searchValue: "" });
    } else {
      this.setState({ searchValue: userObj.user_id });
    }
  }

  triggerFetchAudio(e) {
    e.preventDefault();
    this.props.setPageName("Super Admin QA");
    // const {
    //   userLogin: { loggedUser },
    // } = this.props;
    const {
      filterValues: { startDate, endDate },
      // user_id,
      searchValue,
      selectedOption,
    } = this.state;
    let start_date = "";
    let end_date = "";
    if (startDate !== "" && endDate !== "") {
      let sdate = new Date(startDate);
      let edate = new Date(endDate);
      start_date = `${sdate.getFullYear()}-${
        sdate.getMonth() + 1
      }-${sdate.getDate()} 00:00:00`;
      end_date = `${edate.getFullYear()}-${
        edate.getMonth() + 1
      }-${edate.getDate()} 23:59:59`;
    }
    // this.props.getAuditedListByUser(user_id, start_date, end_date);
    this.props.fetchSQAAudio(
      cookie.load("username"),
      start_date,
      end_date,
      searchValue,
      selectedOption
    );
    this.props.fetchRejectReajonList();
    // this.props.fetchAudioTracks(cookie.load('username'), start_date, end_date, pageNumber, pageNumber * 10)
    // this.setState({ pageNumber })
  }

  render() {
    const {
      QAManagement: { loading, superQACheck, superAuditUserList },
    } = this.props;
    const { filterValues, user_id, searchValue, inputValue, selectedOption } =
      this.state;
    console.log(filterValues);
    console.log(selectedOption);
    console.log("Super Audit List", superAuditUserList.data);

    return (
      <div className="audio-to-trans-page superqa_team">
        <div className="admin-form">
          <div className="userInput">
            <DatePicker
              control="date"
              label="Start Date"
              keys="startDate"
              value={
                filterValues.startDate === "" ? null : filterValues.startDate
              }
              format="MM/dd/yyyy"
              handleDateChange={(value, key) =>
                this.handleDateChange(value, key)
              }
            />
            <DatePicker
              control="date"
              label="End Date"
              keys="endDate"
              value={filterValues.endDate === "" ? null : filterValues.endDate}
              format="MM/dd/yyyy"
              handleDateChange={(value, key) =>
                this.handleDateChange(value, key)
              }
            />
            <Autocomplete
              // value={searchValue}
              onChange={(event, newValue) =>
                this.handleSearchValueChange(event, newValue)
              }
              inputValue={inputValue}
              onInputChange={(event, newInputValue) =>
                this.handleSearchTextChange(newInputValue)
              }
              id="controllable-states-demo"
              options={
                superAuditUserList && superAuditUserList.data.length > 0
                  ? superAuditUserList.data.map((option) => option.login_id)
                  : []
              }
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search here..."
                  // variant="outlined"
                  style={{ width: "80%", marginTop: "-20px" }}
                />
              )}
            />
            <FormControl
              component="fieldset"
              style={{ width: "60%", top: "30px" }}
            >
              <FormLabel component="legend">Select Option</FormLabel>
              <RadioGroup
                aria-label="approval"
                name="approval"
                onChange={this.handleSelectedOption}
                defaultValue="1"
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Approved"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Rejected"
                />
              </RadioGroup>
            </FormControl>
            <div className="btn-wrapper">
              <Button
                disabled={
                  searchValue !== "" &&
                  filterValues.endDate !== "" &&
                  filterValues.startDate !== ""
                    ? false
                    : true
                }
                onClick={(e) => this.triggerFetchAudio(e)}
                variant="contained"
                color="primary"
              >
                Search
              </Button>
            </div>
          </div>
        </div>
        {/* <PlayCircleFilledIcon />
                            <p style={{ paddingLeft: 10 }}>{item.file_path.replace(`http://10.101.1.134/rec/`, ``)}</p> */}
        {this.state.model ? this.renderRejectReasonModel() : null}
        {console.log(superQACheck)}
        {loading ? (
          <Loader />
        ) : (
          <div className="audio-result-contnet">
            {superQACheck.data.length >= 1 ? (
              this.rederAudioFiles(superQACheck.data)
            ) : (
              <p style={{ textAlign: "center", padding: 20 }}>
                No data Found!!.
              </p>
            )}
            {/* <p style={{ textAlign: "center", padding: 20 }}>Enter the File name to dispaly the Audio files.</p> */}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userLogin, QAManagement } = state;
  //const { QAManagement, loading, success, error } = state.AudioToTrackReducer

  return {
    QAManagement,
    //loading,
    userLogin,
    //success,
    //error
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getAuditedListByUser,
    fetchQATranscriptionAudio,
    setPageName,
    superQAAudioDecision,
    fetchSQAAudio,
    SQAAudioDecision,
    fetchRejectReajonList,
    fetchAuditUserList,
  })(ApproveTranscript)
);
